import { BaseTelemetryService } from './telemetry';

const getIntercomID = (joyEnv: Window['joyEnv']) => {
  if (joyEnv && joyEnv.JOY_CONFIG_INTERCOM_APP_ID) {
    return joyEnv.JOY_CONFIG_INTERCOM_APP_ID;
  } else {
    return 'bqzir9g2';
  }
};

const APP_ID = getIntercomID(window.joyEnv);

class IntercomService implements BaseTelemetryService {
  public name: string = 'intercom';
  public appId: string;
  public active: boolean = false;

  public init() {
    if ((window as any).Intercom) {
      return Promise.resolve('intercom is already loaded');
    }
    this.appId = APP_ID;

    (window as any).intercomSettings = {
      app_id: this.appId
    };

    this._setupGlobal();
    return this._loadLibrary();
  }

  public update = () => {
    if (this.active) {
      (window as any).Intercom('update');
    }
  };

  public show = () => {
    if (this.active) {
      (window as any).Intercom('show');
    }
  };

  public hide = () => {
    if (this.active) {
      (window as any).Intercom('hide');
    }
  };

  public showNewMessage(content: string) {
    if (this.active) {
      (window as any).Intercom('showNewMessage', content);
    }
  }

  public sendEvent(event: string) {
    if (this.active) {
      (window as any).Intercom('trackEvent', event);
    }
  }

  public destroy() {
    if (this.active) {
      (window as any).Intercom('shutdown');
    }
  }

  private _setupGlobal = () => {
    const i: any = function() {
      i.c(arguments);
    };

    i.q = [];

    i.c = function(args: any) {
      i.q.push(args);
    };

    (window as any).Intercom = i;
  };

  private _loadLibrary() {
    return new Promise((resolve, reject) => {
      const d = window.document;
      const s = d.createElement('script');
      const b = d.getElementsByTagName('body')[0];

      b.appendChild(s);

      s.onload = () => {
        this.active = true;
        resolve('intercomz');
      };

      s.onerror = () => {
        reject();
      };

      s.type = 'text/javascript';
      s.src = 'https://widget.intercom.io/widget/' + this.appId;
    });
  }
}

export let intercomService = new IntercomService();
